import MoneyProto from '@square/dashboard-data/models/squareup/common/money-proto';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import ThirdPartyFeeEntity from '@square/dashboard-data/models/squareup/beemo/api/v2/models/third-party-fee-entity';
export default ProtoBaseModel.extend({
  amount: attr(MoneyProto),
  thirdPartyFeeEntity: attr(ThirdPartyFeeEntity)
});